export default __webpack_public_path__ + "static/media/enlarge.65a3fb98.svg";